// extracted by mini-css-extract-plugin
export default {"pulse":"Pulse_pulse__Kp1j8"};